import React, { useEffect } from 'react';
import ApprovalFormContainer from './ApprovalFormContainer';
import { useDispatch, useSelector } from 'react-redux';
import DetailTemplate from '../../components/common/template/DetailTemplate';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PurchaseBillHistoryForApproval from '../projectmng/bill_mng/PurchaseBillHistoryForApproval';
import SalesBillHistoryForApproval from '../projectmng/bill_mng/SalesBillHistoryForApproval';
import OrderBookInfoContainer from '../projectmng/obtainorder/OrderBookInfoContainer';
import { viewProject } from '../../modules/projectModule/project';
import { viewOrder } from '../../modules/projectModule/order';
import ApprovalTaxSummary from '../../components/approval/ApprovalTaxSummary';
import { viewApprovalTaxbillByTrjId } from '../../modules/approvalModule/issue-taxbills';

const ApprovalTaxViewContainer = ({ id }) => {
  const dispatch = useDispatch();
  const { user, approval, taxbill, prjUuid, roUuid, project, receiveOrderInf } =
    useSelector(({ auth, userModule, approvalModule, projectModule }) => ({
      user: auth.user,
      approval: userModule.approval.approval,
      prjUuid: userModule.approval.prjUuid,
      roUuid: userModule.approval.roUuid,
      project: projectModule.project.project,
      receiveOrderInf: projectModule.order.receiveOrderInf,
      taxbill: approvalModule.issueTaxbills.taxbill,
    }));

  useEffect(() => {
    if (prjUuid) {
      dispatch(viewProject(prjUuid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prjUuid]);

  useEffect(() => {
    if (roUuid) {
      dispatch(viewOrder(roUuid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roUuid]);

  useEffect(() => {
    if (id) {
      dispatch(viewApprovalTaxbillByTrjId(id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

 return (
  <>
    <DetailTemplate title="결재 정보">
      <ApprovalTaxSummary info={approval} taxbill={taxbill} />
      <Box  sx={{
              position: 'sticky',
              top: 80,           
              zIndex: 1200,      
              bgcolor: '#fff',   
              my: 1,             
              borderBottom: '1px solid',
              borderColor: 'divider',
              boxShadow: '0 4px 2px -2px rgba(0,0,0,0.05)', 
            }}>
        <ApprovalFormContainer docuCd={id} user={user} type="tax" />
      </Box>
      {approval?.docuTxt && (
        <Box sx={{ mt: 1, border: '1px solid #e2e8f0', borderRadius: 1, p: 2, bgcolor: '#fdfdfd' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, color: '#555' }}>
            결재 참고사항
          </Typography>
          <Typography variant="body2" sx={{ color: '#333', whiteSpace: 'pre-wrap' }}>
            {approval.docuTxt}
          </Typography>
        </Box>
      )}
      <Box sx={{ border: '1px solid #e2e8f0', borderRadius: 1, mb: 1  }}>
        <Box sx={{ px: 0.5, pt: 1.2, bgcolor: 'rgba(25, 118, 210, 0.15)' }}>
          <Box sx={{ pb: 0.8, mx: 1, backgroundColor: 'transparent' }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', lineHeight: 1.2 }}>
              상세 내역
            </Typography>
          </Box>
        </Box>
        <OrderBookInfoContainer
          orderInfo={receiveOrderInf}
          project={project}
          isLink
        />
      </Box>
      <Box sx={{ border: '1px solid #e2e8f0', borderRadius: 1, mb: 1 }}>
        <Box sx={{ px: 0.5, pt: 1.2, bgcolor: 'rgba(25, 118, 210, 0.15)' }}>
          <Box sx={{ pb: 0.8, mx: 1, backgroundColor: 'transparent' }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', lineHeight: 1.2 }}>
              매입 계산서 내역
            </Typography>
          </Box>
        </Box>
        <Box sx={{ p: 1 }}>
          <PurchaseBillHistoryForApproval docuCd={id} />
        </Box>
      </Box>
      <Box sx={{ border: '1px solid #e2e8f0', borderRadius: 1 }}>
        <Box sx={{ px: 0.5, pt: 1.2, bgcolor: 'rgba(25, 118, 210, 0.15)' }}>
          <Box sx={{ pb: 0.8, mx: 1, backgroundColor: 'transparent' }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', lineHeight: 1.2 }}>
              매출 계산서 내역
            </Typography>
          </Box>
        </Box>
        <Box sx={{ p: 1 }}>
          <SalesBillHistoryForApproval docuCd={id} />
        </Box>
      </Box>
    </DetailTemplate>
    {/*
    <DetailTemplate title="상세 내역">
      
    </DetailTemplate>

    <DetailTemplate title="회계 증빙 내역">
      
    </DetailTemplate>
     */}
  </>
);

};

export default ApprovalTaxViewContainer;
